module.exports = __webpack_public_path__ + "img/login_demo_mobile.69b7c5ae.png";